module.exports = __webpack_public_path__ + "static/img/img04.289036c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en008/img04.jpg
// module id = dX4N
// module chunks = 0